import { render, staticRenderFns } from "./ShopManager.vue?vue&type=template&id=6b97bdc0&scoped=true&"
import script from "./ShopManager.vue?vue&type=script&lang=js&"
export * from "./ShopManager.vue?vue&type=script&lang=js&"
import style0 from "./ShopManager.vue?vue&type=style&index=0&id=6b97bdc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97bdc0",
  null
  
)

export default component.exports